import { useFormik } from "formik";
import { useEffect, useState } from "react";
import useEditData from "../../../hooks/useEditData";
import useAddData from "../../../hooks/useAddData";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import FileDisplay from "../../../utils/FileDisplay";
import { NuDate, NuInput, NuTextArea, NuUpload } from "../../../utils/Inputs";
import FormikSelectTwo from "../../../utils/Select";
import { handleKeyDown, ScreenClose } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";

export default function CreateOrEdit({
  data,
  visible,
  onClose,
  refreshData,
  satusData = [],
  id,
  getCompletion = () => {},
}) {
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [createNew, setCreateNew] = useState({
    start_date:"",
    end_date: "",
    reference_number: "",
    performed_by: "",
    process_description: "",
    audit_description: "",
    auditee: "",
    result: "",
    status: "",
  });
  useEffect(() => {
    setCreateNew({
      "start_date": data?.start_date,
      "end_date": data?.end_date,
      "reference_number": data?.reference_number,
      "performed_by": data?.performed_by,
      "process_description": data?.process_description,
      "audit_description": data?.audit_description,
      "auditee": data?.auditee,
      "result": data?.result,
      "status": data?.status,
    })
    if(data?.attachment !== null){
      setFilePathList(data?.attachment)
      setRemoveFilePathList(data?.attachment)
    }
  }, [data]);

  function handleImageChange(e) {
    const files = Array.from(e.target.files);
    setSelectedFile(files);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit:  async (value, { resetForm }) => {
      if (data?.id) {
        if(removefilePathList){
          let finalArr = removefilePathList.filter(items=>  !filePathList.includes(items) )
          value.files_to_remove = finalArr.map(item=>item.replace(window.WEB_APP_API_URL, "localhost"));
        }else{
          value.files_to_remove = []
        }
        let formdata = new FormData();
        if(selectedFile){
          selectedFile.forEach((file) => {
            formdata.append("attachment_artifact", file);
          });
        }else{
          formdata.append("attachment_artifact", selectedFile);
        }
        formdata.append("audit_schedule", JSON.stringify(value));
        await ScreenClose({ link: "Audit-Schedule", id: data.id });
        await editData({
          url: `/Audit-Schedule/${data.id}/`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          hasFile: true,
          setSelectedFile: setSelectedFile,
          otherFunction: getCompletion,
        });
      } else {
        let formdata = new FormData();
        if(selectedFile){
          selectedFile.forEach((file) => {
            formdata.append("attachment_artifact", file);
          });
        }else{
          formdata.append("attachment_artifact", selectedFile);
        }
        formdata.append("audit_schedule", JSON.stringify(value));
        addData({
          url: `/Audit-Schedule/standard/${id}/`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          otherFunction: getCompletion,
        });
      }
    },
  });
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList !== item);
    setFilePathList(filterList);
  }

  const resetClose = () => {
    if(data){
      ScreenClose({ link: "Audit-Schedule", id: data.id })
    }
    setSelectedFile(null)
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
              <NuDate
                formik={formik}
                name="start_date"
                label="Start Date"
                width="w-1/2"
                placeholder="Start Date"
              />
              <NuDate
                formik={formik}
                name="end_date"
                label="End Date"
                width="w-1/2"
                placeholder="End Date"
              />
              <NuInput
                formik={formik}
                name="reference_number"
                label="Reference Number"
                width="w-1/2"
                placeholder="Reference Number"
                type="number"
              />
              <NuInput
                formik={formik}
                name="performed_by"
                label="Performed By"
                width="w-1/2"
                placeholder="Performed By"
              />
              <NuTextArea
                formik={formik}
                name="process_description"
                label="Process Description"
                width="w-full"
                placeholder="Enter Process Description"
              />
              <NuTextArea
                formik={formik}
                name="audit_description"
                label="Audit Description"
                width="w-full"
                placeholder="Enter Audit Description"
              />
              <NuInput
                formik={formik}
                name="auditee"
                label="Auditee"
                width="w-1/2"
                placeholder="Auditee"
              />
              <NuInput
                formik={formik}
                name="result"
                label="Results"
                width="w-1/2"
                placeholder="Results"
              />
              <NuUpload
                label="Artefact"
                width="w-1/2"
                onChange={handleImageChange}
                multiple={true}
              />
              <FormikSelectTwo
                formik={formik}
                name="status"
                label="Status"
                width="w-1/2"
                placeholder="Select Status"
                Options={satusData}
                zindex={12}
              />
              <div className=" w-full flex flex-wrap ">
                {data?.attachment &&
                  filePathList.map((i) => {
                    return (
                      <div className=" m-1 my-3">
                        <div className=" relative">
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-bold flex justify-center items-center  -top-2 right-2 z-10"
                            onClick={() => UpdateAttachmentList(i)}
                          >
                            -
                          </div>
                          <FileDisplay
                            data={i}
                            view={true}
                            height={"45px"}
                            width={"45px"}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading || isEditLoading}
                />
                <SubmitButton isLoading={isCreateLoading || isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
